<template>
	<div>
		<div class="ccs-logo-carousel-item"
			 :class="{'ccs-logo-carousel-item_active': isActive }"
			 :title="product.title"
			 @click="$emit('click', product)">
			<img class="ccs-logo-carousel-image" :src="product.image" :alt="product.title" />
			<span class="ccs-logo-carousel-title" v-html="product.title"></span>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			product: Object,
			isActive: Boolean
		}
	}
</script>

<style scoped>
	.ccs-logo-carousel-item {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		height: 100%;
		margin: 0 1px;
		padding: 3px 4px;
		border: 1px solid transparent;
		cursor: pointer;
		line-height: 1.5;
		text-align: center;
		outline: none;
	}

	.ccs-logo-carousel-item_active {
		cursor: default;
		border-color: #ccc;
	}

	.ccs-logo-carousel-image {
		-webkit-user-drag: none;
		margin-bottom: .25em;
		max-height: 4.55em;
		max-width: 115px;
	}

	.ccs-logo-carousel-title {
		font-size: .9em;
		line-height: 1.2em;
		height: 2.35em;
		overflow: hidden;
		font-weight: bold;
		max-width: 100%; /* ie */
	}

	.ccs-small .ccs-logo-carousel-image {
		max-height: 3.55em;
		max-width: 100%;
	}
</style>
